
// デフォルト表示するコンテンツ（性別の数だけ配列に指定）
const defaultContent = ['adult-default', 'child-default'];

// 部位のボタン
const button = document.querySelectorAll('.select-body-btn');

// デフォルトの要素
const def = {
  adult: document.querySelector('[data-part="adult-default"]'),
  child: document.querySelector('[data-part="child-default"]')
};


document.addEventListener('DOMContentLoaded', function(){

  // ページ読み込み時はデフォルトを表示
  showBodyResult( def.adult );
  showBodyResult( def.child );

  // 部位のボタンクリックイベント
  for( let i = 0; i < button.length; i++ ){
    button[i].addEventListener('click', function(e){
      // id を取得
      const id = this.id;
      // データ属性検索用の文字列
      const str = '[data-part="' + id + '"]';
      // id の値を持つデータ属性を取得する
      const part = document.querySelector(str);

      showBodyResult( part );

      // スマホのみ、ボタン押下後にスクロール
      if( mediaQuery.matches ){
        // 親要素を取得
        const parentElm = part.parentNode;
        const rect = parentElm.getBoundingClientRect();
        window.scrollTo({
          top: rect.top + window.pageYOffset,
          left: 0,
          behavior: 'smooth'
        });
      }
    },
    { passive: false });
  }



});



// 表示切り替え
function showBodyResult( target ){
  // 自分以外の要素を取得する
  const partAll = target.parentNode.querySelectorAll('.js-part');
  // 自分以外を非表示
  for( let i = 0; i < partAll.length; i++ ){
    partAll[i].setAttribute('style', 'display: none;');
  }
  // 自分を表示
  target.setAttribute('style', 'display: block;');
}
